import { useEffect, useState } from 'react';

// Open modal dialogs, including the Radix ones that keep their open state to themselves
const OPEN_DIALOG =
  '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [aria-modal="true"]';

// Hidden dialogs left in the page, like the cookie box, have no boxes and do not count
const hasOpenDialog = () =>
  Array.from(document.querySelectorAll(OPEN_DIALOG)).some((el) => el.getClientRects().length > 0);

/**
 * Whether a modal dialog is open anywhere on the page. Read from the page itself, as
 * most modals never report their state to the store. Watches only while enabled.
 */
export const useIsDialogOpen = (isEnabled: boolean) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isEnabled) {
      setIsOpen(false);
      return;
    }
    const check = () => setIsOpen(hasOpenDialog());
    check();
    // Dialogs mount and unmount, or flip their open state in place
    const observer = new MutationObserver(check);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-state', 'aria-modal'],
    });
    return () => observer.disconnect();
  }, [isEnabled]);

  return isOpen;
};
